import { useEffect, useMemo } from "react";
import { useConfig } from "../../../../providers/useConfig";
import { useFlotiqStores } from "../useFlotiqStores/useFlotiqStores";
import { useGoogleMapsStoreLocator } from "../useGoogleMapsStoreLocator";
import { useNaverMapsStoreLocator } from "../useNaverMapsStoreLocator/useNaverMapsStoreLocator";
import { useYandexMapsStoreLocator } from "../useYandexMapsStoreLocator/useYandexMapsStoreLocator";
export const useStoreLocator = ({ defaultLat, defaultLng, storesLimit, defaultZoom, activeStore, cartItems, filterByCartAvailabilityEnabled, filtersTranslations, filtersEnabled, storeDetailsPage, onChooseStore, activeStoreId, flotiqApiKey, flotiqContentType, defaultStoreIcon, storeIcons, isSearchVisible = true, }) => {
    const { locationServiceMapProvider } = useConfig();
    const mapStoreLocator = useMemo(() => {
        switch (locationServiceMapProvider) {
            case "google":
                return useGoogleMapsStoreLocator;
            case "naver":
                return useNaverMapsStoreLocator;
            case "yandex":
                return useYandexMapsStoreLocator;
            default:
                return useGoogleMapsStoreLocator;
        }
    }, [locationServiceMapProvider]);
    const flotiqStoresData = useFlotiqStores({
        cartItems,
        filterByCartAvailabilityEnabled,
        filtersTranslations,
        storesLimit: storesLimit,
        activeStore,
        activeStoreId,
        flotiqApiKey,
        flotiqContentType,
    });
    const storeLocatorData = mapStoreLocator({
        defaultLat,
        defaultLng,
        defaultZoom,
        activeStoreId: flotiqStoresData.activeStoreId,
        storeDetailsPage,
        handleSelectStore: flotiqStoresData.handleSelectStore,
        handleLoadFlotiqStores: flotiqStoresData.getFlotiqStores,
        isStoreDetails: !!activeStore,
        defaultStoreIcon,
        storeIcons,
        isSearchVisible,
    });
    useEffect(() => {
        storeLocatorData.handleLoadMarkers(flotiqStoresData.flotiqStores || []);
    }, [flotiqStoresData.flotiqStores]);
    useEffect(() => {
        if (flotiqStoresData.userMarkerPosition) {
            storeLocatorData.handleLoadUserMarker(flotiqStoresData.userMarkerPosition.lat, flotiqStoresData.userMarkerPosition.lng);
        }
    }, [flotiqStoresData.userMarkerPosition]);
    return {
        ...flotiqStoresData,
        ...storeLocatorData,
        handleSelectStore: storeLocatorData?.handleSelectStoreFromList ?? flotiqStoresData.handleSelectStore,
        storeDetailsPage,
        filtersEnabled,
        onChooseStore,
    };
};
//# sourceMappingURL=useStoreLocator.js.map